<template>
  <f7-page class="dashboard_page withMainToolbar" name="dashboard">
    <f7-navbar sliding no-shadow >
      <f7-nav-title>{{ $t("dashboard.myDashboard") }}</f7-nav-title>
      <f7-nav-right >
        <navbarright></navbarright>
      </f7-nav-right>
    </f7-navbar>
    <AppLayout>
          <template #main>
        <a href="/user/profile" class="text-align-center">
          <f7-card outline :padding="false" class="text-align-center grid-cols-2"
            :class="'border-color-primary highlighted'">
            <img v-if="userAccount && userAccount.avatar" :src="userAccount.avatar"
              :alt="userAccount?.name" width="80px" height="80px" style="border-radius: 50%"></img>
            <f7-badge v-else width="80px" height="80px" style="border-radius: 50%">{{
              $filtersGetInitial.getInitial(userAccount?.name) }}</f7-badge>
            <h2 v-html="userAccount?.name">
            </h2>
          </f7-card></a>

        <div class="grid xsmall-grid-cols-1 small-grid-cols-2">
          <a href="#" @click="goToAccount('standard')" v-if="
            userAccount &&
            userAccount.standard &&
            userAccount.standard !== ''
          ">
            <f7-card outline :padding="false" v-if="
              userAccount &&
              userAccount.standard &&
              userAccount.standard.status !== ''
            " style="height: 250px" :class="userAccount?.standard?.status !== 'ACTIVE'
              ? 'border-color-red highlighted'
              : ''
              " class="border-color-blue highlighted">
              <f7-card-header class="grid grid-rows-2 padding-vertical-half"><span>{{ userAccount?.standard?.tag
              }}</span><span style="font-size: small">
                  №: {{ userAccount?.standard?.id }}</span></f7-card-header>
              <f7-card-content class="padding-top-half">

                <h4 v-if="userAccount?.standard?.type !== ''">
                  {{ $t("common.accountType") }}:
                  {{ getAccountType(userAccount?.standard?.type) }}
                </h4>
                <h4>
                  {{ $t("common.status") }}:
                  <f7-badge v-if="userAccount?.standard && userAccount?.standard?.status !== ''" :color="userAccount?.standard?.status === 'ACTIVE'
                    ? 'primary'
                    : 'deeporange'
                    ">
                    {{ getAccountStatus(userAccount?.standard?.status) }}</f7-badge>
                </h4>

                <!-- <h4>
                  {{ $t("common.kyc_level") }}:
                  <f7-badge color="primary">{{
                    userAccount.standard.kyc_level.split("_")[1]
                  }}</f7-badge>
                </h4> -->

                <p class="text-align-center" href="#">
                  {{ $t("common.seeDetail") }}
                </p>
              </f7-card-content>
            </f7-card>
          </a>
          <a href="#" @click="goToAccount('business')" v-if="userAccount && userAccount?.business !== null">
            <f7-card outline class="border-color-teal highlighted" v-if="
              userAccount?.business !== null &&
              userAccount?.business?.status !== ''
            " :class="userAccount?.business?.status !== 'ACTIVE'
              ? 'border-color-red highlighted'
              : ''
              " style="height: 250px">
              <f7-card-header class="grid grid-rows-2 padding-vertical-half"><span>{{ userAccount?.business?.tag
              }}</span><span style="font-size: small">
                  №: {{ userAccount?.business?.id }}</span></f7-card-header>
              <f7-card-content class="padding-top-half">
                <h4 v-if="userAccount?.business?.type !== ''">
                  > {{ $t("common.accountType") }}:
                  {{ getAccountType(userAccount?.business?.type) }}
                </h4>
                <h4>
                  {{ $t("common.status") }}:
                  <f7-badge v-if="
                    userAccount?.business !== null &&
                    userAccount?.business?.status !== ''
                  " :color="userAccount?.business?.status === 'ACTIVE'
                    ? 'primary'
                    : 'deeporange'
                    ">
                    {{ getAccountStatus(userAccount?.business?.status) }}</f7-badge>
                </h4>

                <h4>
                  {{ $t("common.kyc_level") }}:
                  <f7-badge color="primary">{{
                    userAccount?.business?.kyc_level.split("_")[1]
                  }}</f7-badge>
                </h4>

                <p class="text-align-center" href="#" v-if="
                  userAccount?.business !== null &&
                  userAccount?.business?.status !== ''
                ">
                  <span v-if="userAccount?.business?.status === 'ACTIVE'">
                    {{ $t("common.seeDetail") }}</span>
                  <span v-else>{{ $t("dashboard.activateAccount") }}</span>
                </p>
              </f7-card-content>
            </f7-card>
          </a>
          <a v-else href="/account/business/activate" class="text-align-center">
            <f7-card outline :style="isTablet ? 'height: 250px' : ''" class="border-color-teal highlighted">
              <f7-card-header class="text-align-center padding-vertical-half">BUSINESS</f7-card-header>
              <f7-link class="text-align-center" href="#" icon-size="32" icon-ios="f7:square_stack_3d_up"
                icon-md="material:account_balance" style="top: 50%"></f7-link>
              <p class="text-align-center" href="#" style="top: 50%">
                <span>{{ $t("dashboard.activateAccount") }}</span>
              </p>
            </f7-card>
          </a>
        </div>
        <br />
        <myGroups></myGroups>
        <br />
        <div class="grid grid-cols-2 small-grid-cols-1 text-align-center dashboardGrid">

          <a href="/user/profile">
            <f7-card outline raised class="prodCard border-color-lightblue highlighted">
              <f7-icon size="44px" ios="f7:person_round" md="material:person_outline"></f7-icon>
              <h5 class="margin-top-half">{{ $t("dashboard.goToMyProfile") }}</h5>
            </f7-card>
          </a>

          <!-- <a href="/recipients">
            <f7-card outline raised class="prodCard border-color-pink highlighted">
              <f7-icon size="44px" color="red" ios="f7:person_2_square_stack" md="material:people_outline"></f7-icon>
              <h5 class="margin-top-half">{{ $t("dashboard.goToMyRecipients") }}</h5>
            </f7-card>
          </a> -->

          <!-- <a href="#" @click="getTontineList()">
            <f7-card outline raised class="prodCard border-color-teal highlighted">
              <f7-icon size="44px" color="red" ios="f7:person_3" md="material:group_work"></f7-icon>
              <h5 class="margin-top-half"
                v-html="getGroupType('TONT') ? $t('dashboard.myTontines') : $t('dashboard.createATontine')"></h5>
            </f7-card>
          </a>

          <a href="#" @click="getAssociationList()">
            <f7-card outline raised class="prodCard border-color-orange highlighted">

              <f7-icon size="44px" color="green" ios="f7:heart" md="material:favorite_border"></f7-icon>
              <h5 class="margin-top-half"
                v-html="getGroupType('ASSO') ? $t('dashboard.myAssociationscircles') : $t('dashboard.newAssociationcircle')">
              </h5>
            </f7-card>
          </a>

          <a href="#" @click="getSavingsList()">
            <f7-card outline raised class="prodCard border-color-deeporange highlighted">
              <f7-icon size="44px" color="red" ios="f7:person_3" md="material:group_work"></f7-icon>
              <h5 class="margin-top-half"
                v-html="getGroupType('SAVB') ? $t('dashboard.mySavingsBattles') : $t('dashboard.createSavingsGroup')">
              </h5>
            </f7-card>
          </a>

          <a href="#" @click="getGroupBuyList()">
            <f7-card outline raised class="prodCard border-color-green highlighted">
              <f7-icon size="44px" color="red" ios="f7:person_3" md="material:group_work"></f7-icon>
              <h5 class="margin-top-half"
                v-html="getGroupType('GBUY') ? $t('dashboard.myGroupBuyProjects') : $t('dashboard.createGroupBuy')">
              </h5>
            </f7-card>
          </a>

          <a href="#" @click="getUserWalletList()">
            <f7-card outline raised class="prodCard border-color-blue highlighted">
              <f7-icon size="44px" color="red" ios="f7:circle_grid_hex" md="material:grain">
              </f7-icon>
              <h5 class="margin-top-half"
                v-html="getGroupType('WALL') ? $t('dashboard.myCrowdfunding') : $t('dashboard.newCrowdfunding')">
              </h5>
            </f7-card>
          </a>

          <a @click="getShopList()">
            <f7-card outline raised class="prodCard border-color-purple highlighted">
              <f7-icon size="44px" color="red" ios="f7:cart_fill" md="material:store"></f7-icon>
              <h5 class="margin-top-half"
                v-html="getGroupType('SHOP') ? $t('dashboard.myShops') : $t('dashboard.newShop')">
              </h5>
            </f7-card>
          </a> -->

          <a href="/sell">
            <f7-card outline raised class="prodCard border-color-purple highlighted">
              <f7-icon size="44px" ios="f7:bag_fill" md="material:storefront" />
              <h5 class="margin-top-half">{{ $t("dashboard.sellerHub") }}</h5>
            </f7-card>
          </a>

          <a href="/dashboard/admin">
            <f7-card outline raised class="prodCard border-color-deeporange highlighted">
              <f7-icon size="44px" ios="f7:gearshape_fill" md="material:admin_panel_settings" />
              <h5 class="margin-top-half">{{ $t("adminDashboard.title") }}</h5>
            </f7-card>
          </a>
        </div>
       </template>
        </AppLayout>
  </f7-page>
</template>
<style scoped>
.dashboardColBorderRight {
  border-right: 1px solid var(--f7-theme-color);
}

.card-outline {
  padding: 16px !important;
  margin: 8px;
}

.prodCard {
  max-height: 100px !important;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: inherit;
}
</style>
<script setup>
import { computed, onMounted } from "vue";
import { f7 } from "framework7-vue";
import navbarright from "../components/navbarright.vue";
import myGroups from "../components/myGroups.vue";
import AppLayout from "@/components/common/AppLayout.vue";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import { useTabletScreen } from "../js/composables/useMediaQuery.js";
import { useKeycloakStore } from "../js/pinia-stores/keycloak.js";
import { useStripeStore } from "../js/pinia-stores/stripe.js";
import i18n from "@/js/i18n.js";
import _ from "lodash";

const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const accountStore = useAccountStore();
const authStore = useAuthStore();
const keycloakStore = useKeycloakStore();

const stripeStore = useStripeStore();


const getProfile = computed(() => authStore.profile);
const isAuthenticated = computed(() => !!authStore.token);
const isProfileLoaded = computed(() => !!authStore.profile);
const userAccount = computed(() => accountStore.userAccount);
const userGroupList = computed(() => accountStore.userGroupList);
const users = computed(() => accountStore.users);
const phoneNumberDetail = computed(() => authStore.phoneNumberDetail);
const mobilePhoneError = computed(() => authStore.mobilePhoneError);
const profile = computed(() => authStore.profile);
const isTablet = useTabletScreen().matches;


const businessColor = computed(() => {
  const acct = userAccount.value;
  if (!acct) return "";
  if (
    (acct.business && acct.business.status !== "ACTIVE") ||
    acct.business === null
  ) {
    return "color-pink text-color-pink";
  }
  return "";
});

onMounted(() => {
  const userId = keycloakStore.subject || (authStore.profile && authStore.profile.sub);
  if (!userAccount.value && keycloakStore.authenticated) {
    accountStore.loadAccount(userId);
  }
  if (!userGroupList.value && userId) {
    accountStore.getMyGroupList(userId);
  }
  if (isTablet.value == false) {
    f7.$("div.dashboard_page.page-content").addClass("hide-bars-on-scroll");
  }
});

function goToAccount(accountType) {
  props.f7router.navigate(
    `/account/${accountType}/${accountType === "standard"
      ? userAccount.value.standard.id
      : userAccount.value.business.id
    }`
  );
}

function reoauth() {
  stripeStore.stripeOnbordingRedirect(userAccount.value.standard.stripeAccountId);
}

function getAccountStatus(status) {
  switch (status) {
    case "ACTIVE":
      return i18n.global.t("common.active");
    case "INACTIVE":
      return i18n.global.t("common.inActive");
    case "KYC_REQUIRED":
      return i18n.global.t("common.kycRequired");
    case "SUSPENDED":
      return i18n.global.t("bankAccount.suspended");
    default:
      return i18n.global.t("bankAccount.inActive");
  }
}

function getAccountType(type) {
  return type === "STANDARD"
    ? i18n.global.t("common.standard")
    : i18n.global.t("common.business");
}




</script>
